import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TrackingProvider } from '@g4/trackster';
import tracking from '@g4/g4-analytics';
import TagManager from './TagManager';

class AnalyticsProvider extends Component {
  render() {
    return (
      <React.Fragment>
        <TagManager />
        <TrackingProvider
          trackClick={options => {
            tracking.click(null, options);
          }}
          trackImpression={options => {
            if (process.env !== 'production') {
              throw new Error('Impression Tracking Not Yet Implemented');
            }
          }}
          trackFormError={options => {
            if (process.env !== 'production') {
              throw new Error('Form Error Tracking Not Yet Implemented');
            }
          }}
          children={this.props.children}
        />
      </React.Fragment>
    );
  }
}

AnalyticsProvider.propTypes = {
  children: PropTypes.node,
};

export default AnalyticsProvider;
